import { createSelector } from 'reselect'
import { getTokenFields } from './index'
import { formatDate, formattedTimeOffset } from 'app/services/date'

export const getAddingOrEditingCustomEvent = createSelector(
  state => state.customEvent.addingOrEditingCustomEvent,
  addingOrEditingCustomEvent => {
    return addingOrEditingCustomEvent
  }
)

export const getEvent = createSelector(
  state => state.customEvent.event,
  event => {
    return event
  }
)

const transformTime = t => {
  let date = new Date(formatDate(t, 'YYYY-MM-DD'))
  date = new Date(date.valueOf() + date.getTimezoneOffset() * 60000)
  let value = t - date.valueOf()
  let label = formattedTimeOffset(value)
  return { value: value.toString(), label }
}

export const getCustomEventInitialValues = createSelector(
  state => state.customEvent.event,
  state => state.customEvent.slotInfo,
  (event, slotInfo) => {
    if (event) {
      const timeData = {
        startDate: formatDate(event.start, 'YYYY-MM-DD'),
        startTime: transformTime(event.start),
        endDate: formatDate(event.end, 'YYYY-MM-DD'),
        endTime: transformTime(event.end)
      }

      if (event.type === 'BROKER_VALUATION') {
        return {
          ...timeData,
          title: event.brokerValuationData.name,
          address: event.brokerValuationData.address
        }
      }

      if (event.type === 'CUSTOM_EVENT') {
        return {
          ...timeData,
          title: event.customEventData.title,
          address: event.customEventData.address,
          description: event.customEventData.description
        }
      }
    } else if (slotInfo) {
      return {
        startDate: formatDate(slotInfo.start, 'YYYY-MM-DD'),
        startTime: transformTime(slotInfo.start),
        endDate: formatDate(slotInfo.end, 'YYYY-MM-DD'),
        endTime: transformTime(slotInfo.end)
      }
    } else {
      return {}
    }
  }
)

export const getEventParticipants = createSelector(
  state => state.customEvent.event,
  event => {
    let participants = []
    if (event && event.participants) {
      participants = event.participants.map(p => {
        return { value: p.participantEmail, label: p.participantEmail }
      })
    }

    return participants
  }
)

export const getEventType = createSelector(
  state => state.customEvent.eventType,
  eventType => {
    return eventType
  }
)

export const getEventPayload = createSelector(
  state => state.form.customEventForm,
  state => getTokenFields(state),
  state => state.customEvent.eventType,
  state => state.directAnnonceLead.selectedDirectAnnonceLead,
  (customEventForm, tokenFields, eventType, directAnnonceLead) => {
    if (!tokenFields || !customEventForm) {
      return null
    }

    const { values = {} } = customEventForm
    const { startDate, startTime, endDate, endTime } = values

    let start = null
    let end = null

    if (startDate && startTime && endDate && endTime) {
      let selectedStartDate = new Date(values.startDate)
      selectedStartDate = new Date(
        selectedStartDate.valueOf() +
          selectedStartDate.getTimezoneOffset() * 60000
      )
      start = selectedStartDate.valueOf() + parseInt(values.startTime.value)

      let selectedEndDate = new Date(values.endDate)
      selectedEndDate = new Date(
        selectedEndDate.valueOf() + selectedEndDate.getTimezoneOffset() * 60000
      )
      end = selectedEndDate.valueOf() + parseInt(values.endTime.value)
    }

    let participants = []
    if (values.participants && values.participants.length > 0) {
      participants = values.participants.map(participant => ({
        participantEmail: participant.value
      }))
    }

    let payload = {
      start: start,
      end: end,
      property: null,
      broker: tokenFields.user_id,
      participants,
      landlord: null,
      client: null,
      reason: null,
      serviceReason: null,
      brokerValuationData: null,
      valuationData: null,
      showData: null,
      customEventData: null
    }

    if (eventType === 'BROKER_VALUATION') {
      return {
        ...payload,
        isConfirmed: false,
        status: 'PENDING',
        type: eventType,
        brokerValuationData: {
          name: values.title,
          address: values.address,
          directAnnonceLeadAssignation: directAnnonceLead.id
        }
      }
    }

    if (eventType === 'CUSTOM_EVENT') {
      return {
        ...payload,
        isConfirmed: true,
        status: 'CONFIRMED',
        type: eventType,
        customEventData: {
          title: values.title,
          description: values.description,
          address: values.address
        }
      }
    }

    return payload
  }
)
